// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExceptionOutlinedSvg from "@ant-design/icons-svg/es/asn/ExceptionOutlined";
import AntdIcon from '../components/AntdIcon';

var ExceptionOutlined = function ExceptionOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExceptionOutlinedSvg
  }));
};

ExceptionOutlined.displayName = 'ExceptionOutlined';
export default React.forwardRef(ExceptionOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ExceptionOutlined.js
// module id = 1029
// module chunks = 0